import type { SchemaInput } from '../shared/schema-input.js';
import { isSchemaRecord, isString } from '../shared/runtime-values.js';
import { getCurrentLocale, t } from './i18n.js';

export function trackDataSummary(value: SchemaInput): string | null {
  if (!isSchemaRecord(value) || !Array.isArray(value.times)) return null;
  const pending: SchemaInput[] = [value.times];
  let count = 0;
  let start = Infinity;
  let end = -Infinity;
  while (pending.length) {
    const item = pending.pop();
    if (Array.isArray(item)) {
      for (const child of item) pending.push(child);
    } else if (isString(item)) {
      const time = /^\d{4}-\d{2}-\d{2}T/.test(item) ? Date.parse(item) : NaN;
      if (!Number.isFinite(time)) return null;
      count++;
      start = Math.min(start, time);
      end = Math.max(end, time);
    } else if (item !== null) return null;
  }
  if (!count) return null;
  const locale = getCurrentLocale();
  const date = new Intl.DateTimeFormat(locale, { dateStyle: 'medium', timeStyle: 'long', timeZone: 'UTC' });
  const lines = [
    t('data_layers.track_timestamps').replace('{count}', count.toLocaleString(locale)),
    `${t('data_layers.track_start')}: ${date.format(start)}`,
    `${t('data_layers.track_end')}: ${date.format(end)}`,
  ];
  const other = Object.keys(value).filter((key) => key !== 'times');
  if (other.length) lines.push(other.join(', '));
  return lines.join('\n');
}
